export interface IRegisterForm {
  password1: string;
  password2: string;
  user: {
    email: string;
    firstName: string;
    lastName: string;
  };
}

export const initialAuthStore = {
  errors: {},
  isAuthenticated: false,
  token: '',
  user: {
    email: '',
    firstName: '',
    lastName: '',
  }
};

export const getAuthStore = () => {
  const savedAuthStore = localStorage.getItem('auth');
  if (savedAuthStore !== null) {
    return JSON.parse(savedAuthStore);
  }
  return initialAuthStore;
};

export const authStore = getAuthStore();

export interface IAuthStore {
  isAuthenticated: boolean;
  token: string;
  user: {
    email: string;
    firstName: string;
    lastName: string;
  };
  errors: any;
}
